<template>
  <div class="box">
     <!-- 给按钮加点击事件  -->
    <div @click="showM">
          <!-- 一级按钮  -->
      <slot name="title"></slot>
    </div>
        <!--  二级盒子  -->
        
        <!--  加v-if操作 隐藏显示效果 -->
    <slot v-if="show" name="dropdown"></slot>
  </div>
</template>

<script>
  export default {
    name: "dropdown",
    props: ["isshow"],
    data() {
      return {
        // 默认二级盒子关闭
        show: null
      }
    },
    mounted(){
         this.show=this.isshow;
    },
    methods: {
      showM() {
        this.show = !this.show
      },
      showflase(){
        this.show=false
      },
      commitClick(value) {
      // 向父级暴露dropdown事件，并把值传入
        this.$emit('change-item',value)
      }
    }
  }
</script>

<style scoped>
  .box {
    display: inline-block; /* 行内块 */
    position: relative; /* 相对定位 */
   
    margin-left:100px
  }
</style>



// WEBPACK FOOTER //
// src/components/drop/dropdown.vue